import clsx from "clsx";

import type { MarqueeStoryblok } from "@/types/blok-types";

import styles from "./marquee.module.css";

const Marquee = ({ blok }: { blok: MarqueeStoryblok }) => {
  return (
    <div className={styles.marquee}>
      <div className={styles.marquee__element}>
        <p>{blok.text}</p>
      </div>
      <div className={clsx(styles.marquee__element, styles.second__marquee)}>
        <p>{blok.text}</p>
      </div>
    </div>
  );
};
export default Marquee;
